import React, { Component } from "react";
import { checkUser, getAvailableCities, getPackages, createFinalOrder } from "../../../services/provider/createOrder";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AddIcon from '@mui/icons-material/Add';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead, { getTableHeadUtilityClass } from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DialogTitle from '@mui/material/DialogTitle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import { ProviderAffiliateOrdersName, USER } from "../../../constants/provider/constant";
import { getAgeOfUser, isDateBeforeToday } from "../../../services/provider/common";
class CreateOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      eligibleContracts: [{
        categoryItemTypeId: 'c920aa2144b9e51184af002219349965',
        value: 'Health Check'
      }, {
        categoryItemTypeId: 'f4a83a18cec74f1786b8fd2b9aff4c0c',
        value: 'Lab Test'
      }],
      rows: [
        { name: 'Frozen yoghurt', category: 'Health Check', package: 'Lifecare Basic Health checkup - ₹479', appointment: '24/12/1997' },
      ],
      cardDashboards: [
        { dashbaordId: 1, name: 'verifyuser', disabled: false },
        { dashbaordId: 2, name: 'adduser', disabled: false },
        { dashbaordId: 3, name: 'addpackage', disabled: false },
        { dashbaordId: 4, name: 'displaypackage', disabled: false }
      ],
      primaryMobileNumberError: null,
      emailError: null,
      packageContractDetails: [],
      createOrderResponseSuccess: false,
      openCreateOrderSuccessPopUp: false,
      createOrderResponseMessage: "",
      indexOfUpdateBeneficiary: null,
      indexOfUpdatePackage: null,
      showEditBeneficiaryBtnBtn: false,
      showEditPackageBtn: false,
      showBeneficiary: false,
      beneficiaryDetails: [],
      packageDetails: null,
      cities: [],
      packages: [],
      checkUserFlag: false,
      checkUserMessage: '',
      mobileNumber: '',
      email: '',
      EmailIdNotOfUser: false,
      username: '',
      dob: '',
      gender: '',
      address: '',
      selectbeneficiary: '',
      category: '',
      city: '',
      package: '',
      appointmentDate: '',
      appointmentDateError: null,
      pastOrder: false,
      Keyword: USER && USER.user ? ProviderAffiliateOrdersName[USER.user.providerId] ? ProviderAffiliateOrdersName[USER.user.providerId] : null : null,
      // USER && USER.user.firstName && USER.user.firstName.toLowerCase().indexOf("lifecare") > -1 ? 'lifecare' : USER.user.firstName.toLowerCase().indexOf("diagright") > -1 ? 'diagright' : null,
    }
  }

  resetForm() {
    this.setState({
      packageContractDetails: [],
      openCreateOrderSuccessPopUp: true,
      indexOfUpdateBeneficiary: null,
      indexOfUpdatePackage: null,
      showEditBeneficiaryBtnBtn: false,
      showEditPackageBtn: false,
      showBeneficiary: false,
      beneficiaryDetails: [],
      packageDetails: null,
      cities: [],
      packages: [],
      checkUserFlag: false,
      checkUserMessage: '',
      mobileNumber: '',
      email: '',
      EmailIdNotOfUser: false,
      username: '',
      dob: '',
      gender: '',
      address: '',
      selectbeneficiary: '',
      category: '',
      city: '',
      package: '',
      appointmentDate: '',
      pastOrder: false,
      Keyword: USER && USER.user && USER.user.firstName && USER.user.firstName.toLowerCase().indexOf("lifecare") > -1 ? 'lifecare' : USER && USER.user && USER.user.firstName && USER.user.firstName.toLowerCase().indexOf("diagright") > -1 ? 'diagright' : null,
    })
  }
  handleClickOpenCreateOrderSuccessPopUp() {
    this.setState({
      openCreateOrderSuccessPopUp: true,
    })
  }

  handleClickCloseCreateOrderSuccessPopUp() {
    this.setState({
      openCreateOrderSuccessPopUp: false,
    })
  }
  submitDetails() {
    let payload = {
      AddressLine1: this.state.address,
      Check: this.state.EmailIdNotOfUser,
      DateOfBirth: new Date(this.state.dob).toISOString(),
      Email: this.state.email,
      Keyword: this.state.Keyword,
      Phone: this.state.mobileNumber,
      PrefDateTime: new Date(this.state.appointmentDate).toISOString(),
      firstName: this.state.username,
      gender: this.state.gender,
      packageWithContract: this.state.packageContractDetails
    }
    console.log("payload :", payload);
    createFinalOrder(payload).then(res => {
      if (res.data.cartItem && res.data.cartItem.isSuccess) {
        this.setState({
          openCreateOrderSuccessPopUp: true,
          createOrderResponseSuccess: res.data.cartItem.isSuccess,
          createOrderResponseMessage: "Order Created, Order Number:"+ res.data.cartItem.orderNumber,
        }, () => {
          this.resetForm()
        })
      } else {
        this.setState({
          openCreateOrderSuccessPopUp: true,
          createOrderResponseSuccess: res.isSuccess,
          createOrderResponseMessage: res.errorMessage
        })
      }
    })
  }

  validatePrimaryMobileNumber = () => {
    let indianPhoneNumberRegex = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[56789]\d{9}$/;
    this.setState({
      primaryMobileNumberError: indianPhoneNumberRegex.test(this.state.mobileNumber) ? null : "Enter correct phone number"
    }) // indian phone number regex
  }

  validateEmail = () => {
    let email = this.state.email
    let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.setState({
      emailError: emailRegex.test(this.state.email) ? null : "Enter valid email address"
    }) // regex
  }


  switchCase(name, value, checked) {
    switch (name) {
      case 'mobileNumber':
        this.setState({
          [name]: value,
        }, () => {
          this.validatePrimaryMobileNumber();
        });
        break;
      case 'email':
        this.setState({
          [name]: value,
        }, () => {
          this.validateEmail();
        });
        break;
      case 'EmailIdNotOfUser':
        this.setState({
          [name]: checked,
          email: this.state.mobileNumber + '@mbretailuser.com'
        }, () => {
          console.log("this state suh >>", this.state);
        });
        break;

      case 'category':
        this.setState({
          [name]: value,
          package: '',
          city: '',
        }, () => {
          this.callCity();
          console.log("this state hell >>", this.state);
        });
        break;

      case 'city':
        this.setState({
          [name]: value,
          package: '',
        }, () => {
          this.callPackage();
          console.log("this state hell >>", this.state);
        });
        break;

      case 'appointmentDate':
        this.setState({
          [name]: value,
          pastOrder: isDateBeforeToday(new Date(value))
        }, () => {
          console.log("this state hell >>", this.state);
        });
        break;

      case 'package':
        this.setState({
          [name]: value,
        }, () => {
          console.log("this state hell >>", this.state);
        });
        break;

      default:
        this.setState({
          [name]: value
        }, () => {
          console.log("this state hell >>", this.state);
        });
        break;
    }
  }

  handleFieldChange(event) {
    event.preventDefault();
    const { name, value, checked } = event.target;
    this.switchCase(name, value, checked);
  }

  getUserData() {
    if(this.state.mobileNumber && this.state.email && this.state.emailError === null && this.state.primaryMobileNumberError === null){
      checkUser(this.state.mobileNumber, this.state.email)
      .then(res => {
        if (res) {
          this.setState({
            checkUserFlag: res.isPresent,
            checkUserMessage: res.message
          })
        }
      })
    }
  }

  addBeneficiary() {
    let beneficiaryArray = this.state.beneficiaryDetails;
    this.setState({
      showEditBeneficiaryBtn: false,
    })

    if (this.state.username && this.state.gender && this.state.address && this.state.dob) {
      let beneficiary = {
        username: this.state.username,
        gender: this.state.gender,
        address: this.state.address,
        dob: this.state.dob
      }

      beneficiaryArray.push(beneficiary);
      this.setState({
        beneficiaryDetails: beneficiaryArray,
      }, () => {
        console.log("beneficiaryDetails ::", this.state.beneficiaryDetails);
        this.showBeneficiaryCard(this.state.showBeneficiary);
      })
    }
  }


  editBeneficiaryDetailsSubmit() {
    let index = this.state.indexOfUpdateBeneficiary;
    let beneficiaryArray = this.state.beneficiaryDetails;
    this.setState({
      showEditBeneficiaryBtn: true,
    })
    if (this.state.username && this.state.gender && this.state.address && this.state.dob) {
      let beneficiary = {
        username: this.state.username,
        gender: this.state.gender,
        address: this.state.address,
        dob: this.state.dob
      }
      beneficiaryArray[index] = beneficiary;
      this.setState({
        beneficiaryDetails: beneficiaryArray,
      }, () => {
        this.showBeneficiaryCard(this.state.showBeneficiary)
      })
    }
  }

  editBeneficiaryDetails(index) {
    this.setState({
      indexOfUpdateBeneficiary: index,
      showEditBeneficiaryBtn: true,
    }, () => {
      this.showBeneficiaryCard(this.state.showBeneficiary)
    })
  }

  deleteBeneficiary(index) {
    let beneficiaryArray = this.state.beneficiaryDetails;
    beneficiaryArray.splice(index, 1);
    this.setState({
      beneficiaryDetails: beneficiaryArray,
      username: '',
      gender: '',
      address: '',
      dob: ''
    })

  }

  addNewBeneficiary() {
    this.setState({
      showEditBeneficiaryBtn: false
    }, () => {
      this.showBeneficiaryCard(this.state.showBeneficiary);
    })
  }

  showBeneficiaryCard(showBeneficiary) {
    this.setState({
      showBeneficiary: !showBeneficiary,
    }, () => {
      console.log("this.state.showBeneficiary ::", this.state.showBeneficiary)
    })
  }

  callCity() {
    getAvailableCities(this.state.category).then(res => {
      if (res) {
        this.setState({
          cities: res.cities && res.cities.sort()
        })
      }
    })
  }

  callPackage() {
    getPackages(this.state.category, this.state.city, this.state.Keyword).then(res => {
      if (res) {
        this.setState({
          packages: res.categoryItemTypeResponse
        })
      }
    })
  }

  getpackageUsingId(id) {
    let packageTemp = null;
    this.state.packages && this.state.packages.length > 0 && this.state.packages.map(elem => {
      if (elem.packageId === id) { packageTemp = elem };
    })
    return packageTemp;
  }

  getCategoryUsingId(id) {
    let categoryName = null;
    this.state.eligibleContracts && this.state.eligibleContracts.length > 0 && this.state.eligibleContracts.map(elem => {
      if (elem.categoryItemTypeId === id) { categoryName = elem.value };
    })
    return categoryName;
  }


  addPackageDetails() {
    let packageContractDetailsArray = this.state.packageContractDetails;
    if(this.state.appointmentDate < this.getMinApptDate()){
      this.setState({appointmentDateError:"Can not set date from more than a year ago"})
      return;
    }
    else{
      this.setState({appointmentDateError: null})
    }

    if (this.state.category && this.state.city && this.state.package && this.state.appointmentDate) {
      let packageDetail = {
        City: this.state.city,
        IsPastBooking: this.state.pastOrder,
        packageName: this.getpackageUsingId(this.state.package).packageName + ' - ₹' + this.getpackageUsingId(this.state.package).packagePrice,
        selectedPackage: this.state.package
      }
      let packageWithContract = {
        categoryItemTypeId: this.state.category,
        packageDetail: packageDetail
      }

      packageContractDetailsArray.push(packageWithContract);
      this.setState({
        packageContractDetails: packageContractDetailsArray,
        package: '',
      })
    }
  }

  editPackageDetails() {
    let packageContractDetailsArray = this.state.packageContractDetails;
    this.setState({
      showEditPackageBtn: true
    })

    if (this.state.category && this.state.city && this.state.package && this.state.appointmentDate) {
      let packageDetail = {
        City: this.state.city,
        IsPastBooking: this.state.pastOrder,
        packageName: this.getpackageUsingId(this.state.package).packageName + ' - ₹' + this.getpackageUsingId(this.state.package).packagePrice,
        selectedPackage: this.state.package
      }
      let packageWithContract = {
        categoryItemTypeId: this.state.category,
        packageDetail: packageDetail
      }


      packageContractDetailsArray[this.state.indexOfUpdatePackage] = packageWithContract;
      this.setState({
        packageContractDetails: packageContractDetailsArray,
        showEditPackageBtn: false,
        package: '',
      })
    }
  }

  editPackage(index) {
    let packageContractDetailsArray = this.state.packageContractDetails;
    this.setState({
      indexOfUpdatePackage: index,
      showEditPackageBtn: true,
      city: packageContractDetailsArray[index].packageDetail.City,
      package: packageContractDetailsArray[index].packageDetail.selectedPackage,
      category: packageContractDetailsArray[index].categoryItemTypeId
    }, () => {
      this.callPackage()
    })
  }

  deletePackage(index) {
    let packageContractDetailsArray = this.state.packageContractDetails;
    packageContractDetailsArray.splice(index, 1);
    this.setState({
      packageContractDetails: packageContractDetailsArray,
    })
  }

  getMinApptDate(){
    let minApptDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
    let a = `${minApptDate.getFullYear()}-${minApptDate.getMonth()<9?"0":""}${minApptDate.getMonth()+1}-${minApptDate.getDate()}T00:00`
    console.log(a)
    return a
    //  minApptDate.format("YYYY-MM-DDTH:mm")

  }
  render() {
    return (
      <div>
        <Box
          component="form"
          onSubmit={(event) => this.submitDetails(event)}
          noValidate
          autoComplete="off"
          sx={{
            '.textfield-custom & > :not(style)': { m: 1, p: 0, width: '30%' },
            ' .textfield-custom > label ': { color: '#939393', fontWeight: '500', fontSize: '15px' },
            ' .textfield-custom > div ': { borderRadius: '12px' },
            ' .textfield-custom > div > input': { padding: '14.5px 12px' },
            ' .textfield-custom > div > input': { padding: '14.5px 12px' },
            ' .textfield-custom >  .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': { padding: '14.5px 12px' },
          }}
        >
          <Container maxWidth="xlg" className="pt-3">
            <div className="pb-4 bg-white border border-gray-300 rounded-md p-5 shadow-sm" sx={{ width: '100%' }}>
              <div className="pb-2">
                <span className="text-lg font-semibold">Create Order</span>
              </div>
              <div className="flex content-center space-x-2 ">
                <div className="w-1/3">
                  <TextField
                    className="w-full textfield-custom"
                    id="mobileNumber"
                    type='number'
                    name="mobileNumber"
                    value={this.state.mobileNumber}
                    onChange={(event) => { this.handleFieldChange(event) }}
                    label="Enter Mobile No" />
                  <div className='text-red-600 text-xs'>
                    {this.state.primaryMobileNumberError !== null && this.state.primaryMobileNumberError}
                  </div>
                </div>

                <div className="w-1/3">
                  <TextField
                    className="w-full textfield-custom"
                    id="email"
                    name="email"
                    disabled={this.state.EmailIdNotOfUser}
                    value={this.state.email}
                    onChange={(event) => { this.handleFieldChange(event) }}
                    label="Enter Email" />
                  <div className='text-red-600 text-xs'>
                    {this.state.emailError !== null && this.state.emailError}
                  </div>
                </div>

                <div className="w-1/3">
                  <div className="relative">
                    <div className="float-right text-gray-600">
                      <FormControlLabel
                        control={<Checkbox size="small"
                          id="EmailIdNotOfUser"
                          name="EmailIdNotOfUser"
                          value={this.state.EmailIdNotOfUser}
                          onChange={(event) => {
                            this.handleFieldChange(event)
                          }} />}
                        label="Tick if the above email id is not of user" />
                    </div>
                    <div className={(this.state.mobileNumber && this.state.email && this.state.emailError === null && this.state.primaryMobileNumberError === null) ? 'float-right text-center bg-blue-500 w-1/3 right-0 text-gray-100 px-4 py-2 rounded-lg cursor-pointer' : 'float-right text-center bg-blue-300 w-1/3 right-0 text-gray-100 px-4 py-2 rounded-lg cursor-pointer'} onClick={() => { this.validateEmail(); this.validatePrimaryMobileNumber() ;this.getUserData()}}>
                      Get Data
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </Container>

          {this.state.showBeneficiary &&
            <Container maxWidth="xlg" className="pt-3">
              <div className="pb-4 bg-white border border-gray-300 rounded-md p-5 shadow-sm" sx={{ width: '100%' }}>
                <div className="pb-4 text-sm">
                  <div className="font-semibold">
                    {this.state.beneficiaryDetails.length > 0 ?
                      <span>Beneficiaries ({this.state.beneficiaryDetails.length}) </span> :
                      <span>No Beneficiaries</span>
                    }

                  </div>
                </div>
                <div className="flex content-center space-x-2 pb-5">
                  <TextField
                    className="w-1/3 textfield-custom"
                    id="username"
                    name="username"
                    label="Enter Name"
                    value={this.state.username}
                    onChange={(event) => {
                      this.handleFieldChange(event)
                    }}
                  />
                  <TextField
                    id="dob"
                    className="textfield-custom w-1/3"
                    label="Date of Birth"
                    type="date"
                    name="dob"
                    inputProps={{ max : new Date().toISOString().split("T")[0] }}
                    value={this.state.dob}
                    onChange={(event) => {
                      this.handleFieldChange(event)
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <div className="pl-2.5">
                    <FormControl>
                      <FormLabel id="demo-row-radio-buttons-group-label" style={{ color: '#939393', fontWeight: '500', fontSize: '12px' }}>Gender</FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        className="text-xxs"
                        id="gender"
                        name="gender"
                        value={this.state.gender}
                        onChange={(event) => this.handleFieldChange(event)}
                      >
                        <FormControlLabel value="M" control={<Radio size="small" />} label="Male" />
                        <FormControlLabel value="F" control={<Radio size="small" />} label="Female" />
                      </RadioGroup>
                    </FormControl>
                  </div>

                </div>
                <div className="flex content-center space-x-2">
                  <div className="w-3/4">
                    <TextField
                      id="address"
                      className="textfield-custom w-full"
                      label="Enter Address"
                      name="address"
                      value={this.state.address}
                      onChange={(event) => {
                        this.handleFieldChange(event)
                      }}
                      multiline
                      rows={4}
                    />
                  </div>
                  <div className="w-1/4 relative">
                    {
                      this.state.showEditBeneficiaryBtn ?
                        <span className={(this.state.username && this.state.gender && this.state.address && this.state.dob ? 'bg-blue-500 absolute bottom-0 right-0 text-gray-100 px-10 py-2 rounded-lg cursor-pointer' : 'bg-blue-300 absolute bottom-0 right-0 text-gray-100 px-10 py-2 rounded-lg cursor-pointer')} onClick={() => this.editBeneficiaryDetailsSubmit()}>
                          Edit Beneficiary
                        </span>
                        :
                        <span className={(this.state.username && this.state.gender && this.state.address && this.state.dob ? 'bg-blue-500 absolute bottom-0 right-0 text-gray-100 px-10 py-2 rounded-lg cursor-pointer' : 'bg-blue-300 absolute bottom-0 right-0 text-gray-100 px-10 py-2 rounded-lg cursor-pointer')} onClick={() => this.addBeneficiary()}>
                          Add Beneficiary
                        </span>
                    }

                  </div>
                </div>


              </div>
            </Container>
          }

          {!this.state.showBeneficiary &&
            <Container maxWidth="xlg" className="pt-3">
              <div className="pb-4 bg-white border border-gray-300 rounded-md p-5 shadow-sm" sx={{ width: '100%' }}>
                <div className="pb-2 text-sm">
                  {
                    this.state.checkUserMessage ? <span className={(this.state.checkUserFlag ? 'text-green-600' : 'text-red-500')}>{this.state.checkUserMessage}</span> : <></>
                  }
                  <div className="font-semibold">
                    Beneficiaries ( {this.state.beneficiaryDetails.length} )
                  </div>
                </div>
                <div className="flex space-x-2">
                  {
                    this.state.beneficiaryDetails && this.state.beneficiaryDetails.length > 0 ?
                      this.state.beneficiaryDetails.map((elem, index) => (
                        <div className="p-1 bg-white border border-gray-300 rounded-md shadow-sm flex shadow">
                          <div className="m-auto">
                            <AccountCircleIcon></AccountCircleIcon>
                          </div>
                          <div className="text-xs px-1">
                            <div>{elem.username}</div>
                            <div>{elem.gender}, {getAgeOfUser(elem.dob)} </div>
                          </div>
                          <div className="m-auto pl-2.5">
                            <EditIcon style={{ fontSize: '15px', color: '#316ed5', margin: '0px 5px' }} onClick={() => this.editBeneficiaryDetails(index)}></EditIcon>
                            <DeleteIcon style={{ fontSize: '15px', color: '#D11A2A' }} onClick={() => this.deleteBeneficiary(index)}></DeleteIcon>
                          </div>
                        </div>
                      )) : <></>
                  }

                  {
                    this.state.beneficiaryDetails.length == 0 &&
                    <div className="p-1 bg-white border border-gray-300 rounded-md shadow-sm flex cursor-pointer" onClick={() => this.addNewBeneficiary()}>
                      <div className="m-auto">
                        <AddIcon style={{ color: '#3b81f6' }}></AddIcon>
                      </div>
                      <div className="text-xs px-1 text-blue-500">
                        <div>Add Another</div>
                        <div>Beneficiary</div>
                      </div>
                    </div>
                  }


                </div>

                <div className="pt-10 pb-2">
                  <span className="text-lg font-semibold">Create Details</span>
                </div>

                {/* <div className="pb-5">
                <FormControl className="w-1/5 p-0">
                  <InputLabel id="demo-simple-select-label" style={{ color: '#939393', fontWeight: '500', fontSize: '15px' }}>Select Beneficiary*</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="selectbeneficiary"
                    className="textfield-custom"
                    label="Select Beneficiary*"
                    name="selectbeneficiary"
                    value={this.state.selectbeneficiary}
                    onChange={(event) => {
                      this.handleFieldChange(event)
                    }}
                    style={{ borderRadius: '12px' }}
                  >
                    <MenuItem value={10}>Ten</MenuItem>
                    <MenuItem value={20}>Twenty</MenuItem>
                    <MenuItem value={30}>Thirty</MenuItem>
                  </Select>
                </FormControl>
              </div> */}

                <div className="flex space-x-2">

                  <FormControl className="w-1/5 p-0">
                    <InputLabel id="demo-simple-select-label" style={{ color: '#939393', fontWeight: '500', fontSize: '15px' }}>Category*</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="category"
                      className="textfield-custom"
                      label="Category*"
                      name="category"
                      value={this.state.category}
                      onChange={(event) => {
                        this.handleFieldChange(event)
                      }}
                      style={{ borderRadius: '12px' }}
                    >
                      {
                        this.state.eligibleContracts.map((elem, index) => (
                          <MenuItem key={index} value={elem.categoryItemTypeId}>{elem.value}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>

                  <FormControl className="w-1/5 p-0">
                    <InputLabel id="demo-simple-select-label" style={{ color: '#939393', fontWeight: '500', fontSize: '15px' }}>City*</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="city"
                      className="textfield-custom"
                      label="City*"
                      name="city"
                      value={this.state.city}
                      onChange={(event) => {
                        this.handleFieldChange(event)
                      }}
                      style={{ borderRadius: '12px' }}
                    >
                      {
                        this.state.cities && this.state.cities.length > 0 &&
                        this.state.cities.map((elem, index) => (
                          <MenuItem key={index} value={elem}>{elem}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>

                  <FormControl className="w-1/5 p-0">
                    <InputLabel id="package-label" style={{ color: '#939393', fontWeight: '500', fontSize: '15px' }}>Package/Test Name*</InputLabel>
                    <Select
                      labelId="package-label"
                      id="package"
                      label="Package/Test Name*"
                      name="package"
                      className="textfield-custom"
                      value={this.state.package}
                      onChange={(event) => {
                        this.handleFieldChange(event)
                      }}
                      style={{ borderRadius: '12px' }}
                    >{
                        this.state.packages && this.state.packages.length > 0 &&
                        this.state.packages.map((elem, index) => (
                          <MenuItem key={index} value={elem.packageId}>{elem.packageName} - ₹ {elem.packagePrice}</MenuItem>
                        ))
                      }
                    </Select>
                  </FormControl>

                  <div className="w-1/5">
                  <TextField
                    id="appointmentDate"
                    className="textfield-custom"
                    label="Appointment Date"
                    type="datetime-local"
                    name="appointmentDate"
                    inputProps={ { max: "2050-12-31T23:59" , min : this.getMinApptDate() } }
                    value={this.state.appointmentDate}
                    onChange={(event) => {
                      this.handleFieldChange(event)
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  {
                    this.state.appointmentDateError && <p className="text-red-600 text-xs">{this.state.appointmentDateError}</p>
                  }
                  </div>

                  <div className="my-auto pl-5">
                    {
                      this.state.showEditPackageBtn ?
                        <span className={(this.state.category && this.state.city && this.state.package && this.state.appointmentDate) ? "bg-blue-500 text-gray-100 px-10 py-2 rounded-lg cursor-pointer" : "bg-blue-300 text-gray-100 px-10 py-2 rounded-lg cursor-pointer"} onClick={() => this.editPackageDetails()}>
                          Edit
                        </span>
                        :
                        <span className={(this.state.category && this.state.city && this.state.package && this.state.appointmentDate) ? "bg-blue-500 text-gray-100 px-10 py-2 rounded-lg cursor-pointer" : "bg-blue-300 text-gray-100 px-10 py-2 rounded-lg cursor-pointer"} onClick={() => this.addPackageDetails()}>
                          Add
                        </span>
                    }

                  </div>

                </div>

              </div>
            </Container>

          }

          {
            this.state.packageContractDetails && this.state.packageContractDetails.length > 0 &&
            <Container maxWidth="xlg" className="pt-3">
              <div className="pb-4 bg-white border border-gray-300 rounded-md p-5 shadow-sm" sx={{ width: '100%' }}>

                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650, boxShadow: 'none' }}>
                    <TableHead>
                      <TableRow
                        sx={{ '& td, & th': { color: '#999999' } }}
                      >
                        {/* <TableCell className="text-gray-300">Beneficiary Name</TableCell> */}
                        <TableCell align="left">Category</TableCell>
                        <TableCell align="left">City</TableCell>
                        <TableCell align="left">Package/Test Name</TableCell>
                        <TableCell align="left">Past Order</TableCell>
                        <TableCell align="left"></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.packageContractDetails.map((row, index) => (
                        <TableRow
                          key={row.name}
                          sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                          {/* <TableCell component="th" scope="row">
                          {this.state.username}
                        </TableCell> */}
                          <TableCell align="left">{this.getCategoryUsingId(row.categoryItemTypeId)}</TableCell>
                          <TableCell align="left">{row.packageDetail.City}</TableCell>
                          <TableCell align="left">{row.packageDetail.packageName}</TableCell>
                          <TableCell align="left">{row.packageDetail.IsPastBooking ? 'YES' : 'NO'}</TableCell>

                          <TableCell align="left">
                            <div className="flex space-x-2">
                              <Tooltip title="Edit Package" placement="bottom-end">
                                <EditIcon style={{ color: '#316ed5', cursor: 'pointer' }} onClick={() => this.editPackage(index)}></EditIcon>
                              </Tooltip>
                              <Tooltip title="Delete Package" placement="bottom-end">
                                <DeleteIcon style={{ color: '#D11A2A', cursor: 'pointer' }} onClick={() => this.deletePackage(index)}></DeleteIcon>
                              </Tooltip>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <div className="m-auto pt-4 w-full">
                  <div
                    className={
                      (this.state.mobileNumber && this.state.email &&
                        this.state.beneficiaryDetails && this.state.beneficiaryDetails.length > 0 &&
                        this.state.packageContractDetails) ? "bg-blue-500 text-gray-100 px-10 py-2 rounded-lg cursor-pointer w-10-per m-auto text-center"
                        : "bg-blue-300 text-gray-100 px-10 py-2 rounded-lg cursor-pointer w-10-per m-auto text-center"}
                    onClick={() => this.submitDetails()}>
                    Submit
                  </div>
                </div>

              </div>
            </Container>

          }

          <Dialog
            open={this.state.openCreateOrderSuccessPopUp}
            onClose={(event, reason) => {
              if (reason !== 'backdropClick') {
                this.handleClickCloseCreateOrderSuccessPopUp()
              } else return false;
            }}
            fullWidth={true}
            maxWidth={'sm'}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle>

              <div className="flex justify-end">
                <div className={(this.state.createOrderResponseSuccess) ? "m-auto text-center text-green-600 py-6 font-semibold" : "m-auto text-red-500 text-center py-6 font-semibold"}>
                  {this.state.createOrderResponseMessage}
                </div>
                <div className="text-gray-500" onClick={() => this.handleClickCloseCreateOrderSuccessPopUp()}>
                  <span className="cursor-pointer">
                    <CloseIcon></CloseIcon>
                  </span>
                </div>
              </div>

            </DialogTitle>

          </Dialog>

        </Box>
      </div>
    )
  }
}
export default CreateOrder;
